import { httpClient } from "@allwyn/utils/http-clients/http-client";
import { PlayerContact } from "@allwyn/utils/models/contact";

export async function logLogin(contact: PlayerContact, playerId?: string) {
    await httpClient.post("/api/player/login", {
        playerId: playerId ?? "",
        contact: contact,
    });
}
